import { type Comment as CommentType } from '@/@types/comment'
import type { GetCommentParams } from '@/utils/fetchers/comment'
import { Loader } from '@mantine/core'
import { motion } from 'motion/react'
import { type HTMLAttributes, type ReactNode, Suspense } from 'react'
import CommentReplies from './CommentReplies'
import styles from './CommentRepliesSection.module.css'

export interface CommentRepliesSectionProps extends HTMLAttributes<HTMLDivElement> {
	data: CommentType
	renderComment: (data: GetCommentParams) => ReactNode
}

export default function CommentRepliesSection({
	data,
	renderComment,
	...props
}: CommentRepliesSectionProps) {
	return (
		<Suspense
			fallback={
				<motion.div
					initial={{
						opacity: 0,
					}}
					animate={{
						opacity: 1,
					}}
					exit={{
						opacity: 0,
					}}
					className={styles.loader}
				>
					<Loader />
				</motion.div>
			}
		>
			<CommentReplies data={data} renderComment={renderComment} />
		</Suspense>
	)
}
